export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/mayodeclaro2026.jpg',
	   "funcion": 'Llegó el momento.',
		"url" : 'https://www.facebook.com/reel/948864241251554',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/recuperacontra2026.jpg',
	   "funcion": 'Declaración Modificación',
		"url" : 'https://fb.watch/H17LIAGRzK/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/dulce.jpg',
	   "funcion": 'Declaración Modificación',
				"url" : 'https://www.facebook.com/share/p/1CpN9WepQv/',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]